import { render } from "./MenuTableView2.vue?vue&type=template&id=4b820d4e&scoped=true"
import script from "./MenuTableView2.vue?vue&type=script&lang=js"
export * from "./MenuTableView2.vue?vue&type=script&lang=js"

import "./MenuTableView2.vue?vue&type=style&index=0&id=4b820d4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b820d4e"]])

export default __exports__